export default function HowToPlay() {
  const steps = [
    ["01", "Hit Play", "The audio starts at just 0.1 seconds. Yes, one tenth of a second."],
    ["02", "Guess", "Type any wrestler, tag team, faction, or nickname. Alternate names count."],
    ["03", "Reveal More", "Wrong guess or skip unlocks the next window: 1s → 3s → 5s → 7s → 10s."],
    ["04", "Score Fast", "Earlier win = higher points. Perfect first-try nabs 1,000."],
  ];
  const points = [
    ["0.1s", 1000], ["1s", 850], ["3s", 650], ["5s", 450], ["7s", 250], ["10s", 100],
  ];
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 sm:py-12">
      <div className="text-xs font-mono uppercase tracking-widest text-red-500 mb-1">Rulebook</div>
      <h1 className="font-display text-3xl sm:text-5xl font-black uppercase text-white">How to Play</h1>

      <div className="mt-8 grid gap-4">
        {steps.map(([n, t, d]) => (
          <div key={n} className="flex gap-4 p-4 bg-slate-900/60 border border-slate-800 rounded-xl">
            <div className="font-display font-black text-4xl text-red-500 w-16">{n}</div>
            <div>
              <div className="font-display text-xl font-bold uppercase">{t}</div>
              <div className="text-slate-400 text-sm mt-1">{d}</div>
            </div>
          </div>
        ))}
      </div>

      <h2 className="font-display text-2xl font-black uppercase mt-10">Scoring</h2>
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-2 mt-3">
        {points.map(([s, p]) => (
          <div key={s} className="bg-slate-900/60 border border-slate-800 rounded-xl p-3 text-center">
            <div className="font-mono text-red-500 text-xs uppercase">{s}</div>
            <div className="font-display text-lg font-black">{p}</div>
          </div>
        ))}
      </div>

      <h2 className="font-display text-2xl font-black uppercase mt-10">Modes</h2>
      <ul className="mt-3 space-y-2 text-slate-300 text-sm">
        <li>• <b>Daily Theme</b> — Entrance music, one puzzle a day.</li>
        <li>• <b>Daily Promo</b> — A voice on the mic. Guess who's cutting the promo.</li>
        <li>• <b>Endless</b> — Every past puzzle, no streak pressure.</li>
      </ul>
    </div>
  );
}
